import gql from 'graphql-tag';

export const UPDATE_MANUAL_VIEWERSHIP = gql`
  mutation UpdateCompleteManualViewership(
    $id: ID!
    $benSourceId: Int!
    $watchStationId: Int!
    $premiereDate: ISODateTime!
    $premiereImpressions: Int
    $past30Impressions: Int
    $past60Impressions: Int
    $past90Impressions: Int
    $past365Impressions: Int
    $notes: String
  ) {
    updateManualViewership(
      id: $id
      payload: {
        benSourceId: $benSourceId
        watchStationId: $watchStationId
        type: reported
        premiereDate: $premiereDate
        premiereImpressions: $premiereImpressions
        past30Impressions: $past30Impressions
        past60Impressions: $past60Impressions
        past90Impressions: $past90Impressions
        past365Impressions: $past365Impressions
        notes: $notes
      }
    ) {
      id
      benSourceId
      watchSourceId
      watchStationId
      type
      premiereImpressions
      past30Impressions
      past60Impressions
      past90Impressions
      past365Impressions
      createdAt
      updatedAt
      createdBy {
        id
        email
      }
    }
  }
`;
